// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__29ohe","selected":"Chip_selected__OVzeR"};